import { Component, OnInit, Input, Inject, forwardRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from "@angular/forms";
import { AuthenticationService } from 'app/core/authentication.service';
import { EphemerideService } from 'app/core/ephemeride.service';
import { Ephemeride } from 'app/models/ephemeride';
import { Patients } from 'app/models';
import { PatientService } from 'app/core/patient.service';
import { NotificationsService } from 'app/utils/notifications.service';
import { PersonnelService } from 'app/core/personnels.service';
import { Personnel } from 'app/models/personnel';
import { Router } from '@angular/router';
import { AdminLayoutComponent } from '../admin-layout.component';
import { EphemerideModule } from 'app/ephemeride/ephemeride/ephemeride.module';

@Component({
  selector: 'app-showephemeride',
  templateUrl: './showephemeride.component.html',
  styleUrls: ['./showephemeride.component.css']
})
export class ShowephemerideComponent implements OnInit {
  public ephemeride: Ephemeride[]; 
  public patient : Patients[];
  epheform: FormGroup;
  info: any;
  public page = {
    limit: 15,
    count: 0,
    offset: 0,
    orderBy: "id",
    orderDir: "DESC"
  };
@Input()
ephemerides: Ephemeride;
public cible : Personnel[];
  constructor( 
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private authserve: AuthenticationService,
    private ephemerideService: EphemerideService,
    private patientService: PatientService,
    private notificationService: NotificationsService,
    private personnelService: PersonnelService,
    private router : Router
   ) 
    { }

  ngOnInit() {
      const params = {
        sortName: `${this.page.orderBy}`,
        sortType: `${this.page.orderDir}`,
        page: `${this.page.offset}`,
        size: `${this.page.limit}`
      };
      this.ephemerideService.find(params).subscribe(
        res => {
          this.ephemeride = res.body;
          this.page.count = +res.headers.get("total");
        },
        error => {
          console.error(error);
        }
      );
      this.loadPersonnel();
     
  }

 public ephemerideCount(){
  const params = {
    sortName: `${this.page.orderBy}`,
    sortType: `${this.page.orderDir}`,
    page: `${this.page.offset}`,
    size: `${this.page.limit}`
   };
  this.ephemerideService.find(params).subscribe(
    res => {
      this.ephemeride = res.body;
      this.page.count = +res.headers.get("total");
    },
    error => {
      console.error(error);
    }
  );
  
}


  loadPersonnel(){
    this.personnelService.find().subscribe(cible => {  
            this.cible =cible;
         });
  }
  

  accept(ephemerides?: Ephemeride ){
    console.log(ephemerides);
    this.ephemerideService.update(ephemerides).subscribe(success => {
      console.log("bien fait");
      this.notificationService.addToast(
        `Patient bien modifier`,
        "Info",
        "success"
        );
  });
  this.ngOnInit();
  this.dismiss();
  this.ephemerideCount();
 /* this.refresh();*/
  }


  dismiss() {
    this.activeModal.dismiss("cancelled by user");
  }

  
  refresh(){
    window.location.reload();
   }


  public effectuEphemeride(ephemerides :Ephemeride, event: any) {
  ephemerides.cible=event;
  console.log(event);
    this.ephemerideService.update(ephemerides).subscribe(
    EpemerideUpdated => {
        console.log(EpemerideUpdated);
       /* this.notification.addToast("Statut Bien  modifié", "infos", "success");*/
      },
      error => {
        console.error(error);
      /*  this.notification.addToast("Error", "Attention", "error");*/
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/layouts/admin/showephemeride/showephemeride.component.ts